var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 198,
    viewBox: "0 0 200 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 197.167C154.679 197.167 199.005 153.029 199.005 98.5833C199.005 44.1372 154.679 0 100 0C45.3208 0 0.994629 44.1372 0.994629 98.5833C0.994629 153.029 45.3208 197.167 100 197.167Z",
    fill: "#F0ECFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-completed)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.7738 117.408C78.1636 117.408 61.4529 100.701 61.4529 80.0965V57.7314H136.095V80.0892C136.095 100.701 119.384 117.408 98.7738 117.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6074 147.511C78.6074 143.926 81.5174 141.016 85.104 141.016H97.0133V117.408L103.175 97.9883V117.408V141.024H115.084C118.671 141.024 121.581 143.933 121.581 147.519",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.578 93.035C142.831 93.035 150.325 85.5364 150.325 76.2922V68.6481C150.325 68.1608 149.925 67.7607 149.437 67.7607H129.169L129.707 73.652H143.784C144.134 73.652 144.417 73.9357 144.417 74.2848C144.417 81.9362 140.904 85.1727 135.862 86.0091L126.921 88.5184L133.578 93.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0718 93.035C54.8253 93.035 47.3247 85.5364 47.3247 76.2922V68.6481C47.3247 68.1608 47.7248 67.7607 48.2123 67.7607H68.4805L67.9422 73.652H53.865C53.5158 73.652 53.232 73.9357 53.232 74.2848C53.232 81.9362 56.7459 85.1727 61.7875 86.0091L74.1769 91.7622L64.0718 93.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.304 147.512H66.2427V154.545H133.304V147.512Z",
    fill: "#DDD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.634 154.552H57.9058V175.731H141.634V154.552Z",
    fill: "#DDD0FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.586 74.3791C170.348 74.3791 170.966 73.7641 170.966 73.0055C170.966 72.2468 170.348 71.6318 169.586 71.6318C168.824 71.6318 168.207 72.2468 168.207 73.0055C168.207 73.7641 168.824 74.3791 169.586 74.3791Z",
    fill: "#182A88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.003 67.426C174.764 67.426 175.382 66.811 175.382 66.0524C175.382 65.2937 174.764 64.6787 174.003 64.6787C173.241 64.6787 172.623 65.2937 172.623 66.0524C172.623 66.811 173.241 67.426 174.003 67.426Z",
    fill: "#182A88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.18 69.6194C167.942 69.6194 168.559 69.0044 168.559 68.2457C168.559 67.4871 167.942 66.8721 167.18 66.8721C166.418 66.8721 165.8 67.4871 165.8 68.2457C165.8 69.0044 166.418 69.6194 167.18 69.6194Z",
    fill: "#182A88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1801 50.0051C63.942 50.0051 64.5596 49.3901 64.5596 48.6315C64.5596 47.8728 63.942 47.2578 63.1801 47.2578C62.4182 47.2578 61.8005 47.8728 61.8005 48.6315C61.8005 49.3901 62.4182 50.0051 63.1801 50.0051Z",
    fill: "#5F3FAF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3302 43.9778C60.0921 43.9778 60.7097 43.3628 60.7097 42.6041C60.7097 41.8455 60.0921 41.2305 59.3302 41.2305C58.5683 41.2305 57.9507 41.8455 57.9507 42.6041C57.9507 43.3628 58.5683 43.9778 59.3302 43.9778Z",
    fill: "#5F3FAF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162.218 42.3061H147.385L139.493 53.3166L130.51 42.3061H116.768C112.149 42.3061 108.395 38.5685 108.395 33.9684V12.203C108.395 7.60284 112.149 3.86523 116.768 3.86523H162.229C166.849 3.86523 170.602 7.60284 170.602 12.203V33.9684C170.592 38.5685 166.838 42.3061 162.218 42.3061Z",
    fill: "#182A88"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.547 12.4619L131.499 18.4151L138.103 19.3673L133.329 24.0009L134.451 30.5463L128.547 27.4573L122.651 30.5463L123.773 24.0009L119 19.3673L125.603 18.4151L128.547 12.4619Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153.182 12.4619L156.134 18.4151L162.737 19.3673L157.963 24.0009L159.085 30.5463L153.182 27.4573L147.286 30.5463L148.408 24.0009L143.634 19.3673L150.238 18.4151L153.182 12.4619Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1363 116.834C77.4186 116.834 60.6206 99.9752 60.6206 79.1826V56.6211H135.652V79.1826C135.652 99.9826 118.854 116.834 98.1363 116.834Z",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108.718 104.32C106.049 105.707 103.131 106.684 100.052 107.168",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.192 78.8086C124.192 87.0802 120.703 94.537 115.124 99.7774",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M124.192 66.8301V72.5622",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.373 116.834V140.665H84.3943C80.789 140.665 77.8638 143.601 77.8638 147.219",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.567 116.834V140.665H114.538C118.144 140.665 121.069 143.601 121.069 147.219",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M136.003 66.7422H149.064C149.554 66.7422 149.956 67.1459 149.956 67.6376V75.3514C149.956 84.6871 142.416 92.2468 133.122 92.2468",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M136.544 72.6797H143.381C143.732 72.6797 144.018 72.9659 144.018 73.3182C144.018 81.0393 140.485 84.3054 135.417 85.1494",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3717 66.7422H47.3106C46.8207 66.7422 46.4185 67.1385 46.4185 67.6303V75.344C46.4185 84.6798 53.9582 92.2468 63.253 92.2468",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8298 72.6797H52.9922C52.6412 72.6797 52.356 72.9659 52.356 73.3182C52.356 81.0393 55.8881 84.3054 60.956 85.1494",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M132.841 147.219H65.4302V154.316H132.841V147.219Z",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M141.215 154.316H57.0493V175.689H141.215V154.316Z",
    stroke: "#5F3FAF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15.0708 180.75C14.9512 165.946 26.1873 153.846 40.1604 153.719C54.1405 153.593 65.2002 160.489 65.3198 175.286",
    fill: "#182A88"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M36.634 197.166C50.0597 197.166 60.9434 186.171 60.9434 172.607C60.9434 159.044 50.0597 148.049 36.634 148.049C23.2084 148.049 12.3247 159.044 12.3247 172.607C12.3247 186.171 23.2084 197.166 36.634 197.166Z",
    fill: "#56CABB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0952 173.058L34.0793 179.996L48.9598 164.712",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-completed"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 118,
    fill: "white",
    transform: "translate(47.3247 57.7314)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.5146fe13.svg";
export { ForwardRef as ReactComponent };